// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2YQFF","info":"PatientInfo_info__14dgd"};